<template>
    <div class="EntityDetailsHeader">
        <div class="entity-icon">
            <i :class="entityIcon"></i>
        </div>
        <div class="entity-info">
            <h2 class="entity-name">{{ entityName }}</h2>
            <p v-if="entitySubtitle" class="entity-subtitle">{{ entitySubtitle }}</p>
        </div>
    </div>
</template>

<script>
const ENTITY_ICONS = {
    driver: 'ri-user-line',
    car: 'ri-car-line',
    concession: 'ri-building-line',
};

export default {
    name: 'EntityDetailsHeader',
    props: {
        entityType: {
            type: String,
            default: 'driver',
        },
        entityName: {
            type: String,
            default: '',
        },
        entitySubtitle: {
            type: String,
            default: '',
        },
    },
    computed: {
        entityIcon() {
            return ENTITY_ICONS[this.entityType] || 'ri-information-line';
        },
    },
};
</script>

<style lang="scss" scoped>
.EntityDetailsHeader {
    display: flex;
    align-items: center;
    gap: 12px;

    .entity-icon {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        background-color: rgba(0, 0, 0, 0.05);
        display: flex;
        align-items: center;
        justify-content: center;
        color: var(--color-blue, #3498db);
        font-size: 18px;
        flex-shrink: 0;
    }

    .entity-info {
        flex: 1;
        min-width: 0;

        .entity-name {
            font-size: 16px;
            font-weight: 600;
            color: var(--color-text-black, #1a1a1a);
            margin: 0 0 2px 0;
            word-break: break-word;
            line-height: 1.3;
        }

        .entity-subtitle {
            font-size: 12px;
            color: var(--color-gray, #666);
            margin: 0;
            line-height: 1.3;
        }
    }
}

@media (max-width: 768px) {
    .EntityDetailsHeader {
        margin-bottom: 20px;
        padding-bottom: 16px;
        gap: 12px;

        .entity-icon {
            width: 40px;
            height: 40px;
            font-size: 20px;
        }

        .entity-info {
            .entity-name {
                font-size: 18px;
            }

            .entity-subtitle {
                font-size: 12px;
            }
        }
    }
}
</style>
